var chunkMapping = {
	"52": [
		44052
	],
	"110": [
		60110
	],
	"200": [
		9200
	],
	"266": [
		54266
	],
	"272": [
		95272
	],
	"556": [
		41556
	],
	"601": [
		4982
	],
	"684": [
		40684
	],
	"740": [
		39740
	],
	"876": [
		37876
	],
	"994": [
		60994
	]
};
var idToExternalAndNameMapping = {
	"4982": [
		"default",
		"./MasterDataModule",
		41722
	],
	"9200": [
		"default",
		"./AutomationStudioModule",
		75666
	],
	"37876": [
		"default",
		"./FinanceModule",
		17200
	],
	"39740": [
		"default",
		"./ComplianceModule",
		30946
	],
	"40684": [
		"default",
		"./AccountingModule",
		29058
	],
	"41556": [
		"default",
		"./ProductConfigurationModule",
		36510
	],
	"44052": [
		"default",
		"./QuestionnaireModule",
		74050
	],
	"54266": [
		"default",
		"./UserManagementModule",
		53846
	],
	"60110": [
		"default",
		"./WatchTowerModule",
		29082
	],
	"60994": [
		"default",
		"./JobSchedulerModule",
		43182
	],
	"95272": [
		"default",
		"./DispatcherModule",
		33666
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}